import { getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import { propTypesIllustration } from '../../../shared/constants/Proptypes';

import Button from '../../Atoms/Button';
import Checkbox from '../../Atoms/Checkbox';
import Input from '../../Atoms/Input';
import Picture from '../../Atoms/Picture';

import { getStaticUrl } from '../../../shared/utils/getStaticUrl';

import * as S from './Newsletter.styles';

export const Newsletter = ({
  illustration,
  title,
  description,
  didConsent,
  optinLabel,
  label,
  onClick,
  value,
  onChange,
  onAccept,
  placeholder,
  isFullScreen,
  theme,
}) => {
  if (
    !description ||
    !label ||
    !onChange ||
    !onClick ||
    !placeholder ||
    !title
  ) {
    return null;
  }

  const { localFile, alt } = illustration || '';

  const imageProps = {
    imageObject: getImage(localFile),
    imageUrl: getStaticUrl(localFile?.publicURL),
    altText: alt,
    center: true,
    height: 150,
    width: 150,
  };

  const hasIllustration = !!imageProps?.imageUrl;

  return (
    <S.Newsletter hasIllustration={hasIllustration} isFullScreen={isFullScreen}>
      {hasIllustration && alt && (
        <S.PictureContainer>
          <Picture {...imageProps} />
        </S.PictureContainer>
      )}
      {title && !isFullScreen && <S.Title>{title}</S.Title>}
      {title && isFullScreen && <S.BigTitle>{title}</S.BigTitle>}
      {description && <S.Description>{description}</S.Description>}
      <S.Wrapper>
        <Input
          appearance='outline'
          onChange={onChange}
          placeholder={placeholder}
          type='email'
          value={value ?? placeholder}
        />

        <Button theme={theme} isDisabled={!didConsent} onClick={onClick}>
          {label}
        </Button>
      </S.Wrapper>
      <S.CheckboxWrapper>
        <Checkbox
          isChecked={didConsent}
          text={optinLabel}
          onClick={onAccept}
          isRequired={true}
        />
      </S.CheckboxWrapper>
    </S.Newsletter>
  );
};

Newsletter.propTypes = {
  /**
   * Display an illustration above the title.
   */
  illustration: PropTypes.shape(propTypesIllustration),
  /**
   * Short text. limited to 110 characters.
   */
  description: PropTypes.string.isRequired,
  /**
   * Allow the user to submit or not.
   */
  didConsent: PropTypes.bool,
  /**
   * Set a larger height to the component if true.
   */
  isFullScreen: PropTypes.bool,
  /**
   * Button label.
   */
  label: PropTypes.string.isRequired,
  /**
   * Function updating the consent value.
   */
  onAccept: PropTypes.func.isRequired,
  /**
   * Function called every time the event is triggered.
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Function called every time the event is triggered
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Label of the consent checkbox
   */
  optinLabel: PropTypes.string,
  /**
   * Input placeholder.
   */
  placeholder: PropTypes.string.isRequired,
  /**
   * Card title.
   */
  title: PropTypes.string.isRequired,
  /**
   * Value of the input element.
   */
  value: PropTypes.string,
  /**
   * Button theme.
   */
  theme: PropTypes.string,
};

Newsletter.defaultProps = {
  theme: 'wooclap',
  isFullScreen: false,
};

export default Newsletter;
